import { render } from "./AdminItemList.vue?vue&type=template&id=6d9ccccc&scoped=true"
import script from "./AdminItemList.vue?vue&type=script&lang=js"
export * from "./AdminItemList.vue?vue&type=script&lang=js"

import "./AdminItemList.vue?vue&type=style&index=0&id=6d9ccccc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9ccccc"]])

export default __exports__